import Swal from 'sweetalert';

const showDeleteConfirmation = (onConfirmCallback) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'You will not be able to recover this item!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirmCallback();
    }
  });
};

export default showDeleteConfirmation;